/* eslint-disable no-param-reassign */
import Moment from 'moment';

// Constants
export const CLEAN_CAJA = 'CAJA__CLEAN';
export const SET_PADRONES = 'CAJA__SET_PADRONES';
export const ADD_PADRON = 'CAJA__ADD_PADRON';
export const ADD_PADRONES = 'CAJA__ADD_PADRONES';
export const REMOVE_PADRON = 'CAJA__REMOVE_PADRON';
export const SET_CARGOS_PADRON = 'CAJA__SET_CARGOS_PADRON';
export const SET_SELECTEDROWKEYS = 'CAJA__SET_SELECTEDROWKEYS';
export const SET_RECIBOS = 'CAJA__SET_RECIBOS';
export const SET_RECIBOS_ORDEN = 'CAJA__SET_RECIBOS_ORDEN';
export const SET_RECIBO_CONVENIO = 'CAJA__SET_RECIBO_CONVENIO';

export const SET_NETPAY_RESPONSE = 'CAJA__SET_NETPAY_RESPONSE';
export const SET_CARGOS_PUBLICO_GENERAL = 'CAJA__SET_CARGOS_PUBLICO_GENERAL';
export const CLEAR_NETPAY_RESPONSE = 'CAJA__CLEAR_NETPAY_RESPONSE';
export const SET_SOCKETS_CONNECTED = 'CAJA__SET_SOCKETS_CONNECTED';
export const SET_LAST_PAYMENT_DATA = 'CAJA__SET_LAST_PAYMENT_DATA';
export const SET_PIN_PADRON_AGREGAR_CARGOS = 'CAJA__SET_PIN_PADRON_AGREGAR_CARGOS';
export const SET_PIN_PADRON_INFO = 'CAJA__SET_PIN_PADRON_INFO';
export const SET_PIN_PADRON_COMENTARIO = 'CAJA__SET_PIN_PADRON_COMENTARIO';
export const SET_PIN_PADRON_ALERTAS = 'CAJA__SET_PIN_PADRON_ALERTAS';
export const SET_OBSERVACIONES = 'CAJA__SET_OBSERVACIONES';
export const SET_PADRON_REQUIERE_FETCH = 'CAJA__SET_PADRON_REQUIERE_FETCH';
export const SET_PADRON_PAGO_CONVENIO = 'CAJA__SET_PADRON_PAGO_CONVENIO';
export const SET_LAST_PAYMENT_DATA_CONVENIO = 'CAJA__SET_LAST_PAYMENT_DATA_CONVENIO';
export const SET_RECIBOS_CANCELADOS = 'CAJA__SET_RECIBOS_CANCELADOS';

const initialState = {
  ciudadano: null,
  cargosPublicoGeneral: [],
  padrones: [],
  selectedRowKeys: {},
  lastPaymentData: [],
  netpayResponse: null,
  recibos: [],
  pinPadronAgregarCargos: null,
  pinPadronInfo: null,
  pinPadronComentario: null,
  pinPadronAlertas: null,
  padronPagoConvenio: null,
  reciboConvenio: [],
  lastPaymentDataConvenio: [],
  recibosCancelados: [],
};

export const normalizeCargos = (cargos = []) => {
  const normalized = cargos.filter((e) => e.estados_globales !== 5);
  const cargosNoAccesorios = normalized.filter((c) => !c.es_accesorio);

  const getAccesories = (cargo_padre) => normalized
    .filter((e) => e.cargo_padre === cargo_padre && e.es_accesorio);

  const sorted = cargosNoAccesorios
    .reduce((acum, curr) => acum.concat([...getAccesories(curr.id)
      .sort((a, b) => b.tipo_de_cargo.id - a.tipo_de_cargo.id), curr]), []).reverse();
  return sorted;
};

export const filterCargosSistemasTramites = (cargos) => cargos.filter((cargo) => {
  if (cargo?.cargo_padre) {
    const cargoPadre = cargos.find((_cargo) => _cargo.id === cargo?.cargo_padre);
    if (cargoPadre) {
      return cargoPadre?.tipo_de_cargo?.sistemas || cargoPadre?.tramite || cargoPadre?.convenios;
    }
  }
  return cargo?.tipo_de_cargo?.sistemas || cargo?.tramite || cargo?.convenios;
});

const requireUpdate = (padron) => {
  if ([1, 15].includes(padron.tipo_de_padron)) {
    return !!padron.lada
      || padron.rfc === '&&&&'
      || padron.correo_electronico === 'some@dont_show.com.mx';
  }
  if (padron.tipo_de_padron === 2) {
    return !!padron.numero_de_telefono && !!padron.RFC;
  }
  return false;
};

const mapAlertas = (alertas, cargos) => alertas.map((alerta) => {
  if (!alerta.es_restrictiva) return { ...alerta, cargosBloqueados: [], cargosBloqueadosIds: [] };

  const sistemas = alerta.tipo_de_alerta?.sistemas || [2];
  const tiposDeCargos = alerta.tipo_de_alerta?.cargos || [346];
  const cargosBloqueados = cargos
    .filter((c) => !sistemas.includes(c.tipo_de_cargo.sistemas?.id)
      && !tiposDeCargos.includes(c.tipo_de_cargo.id));
  return { ...alerta, cargosBloqueados, cargosBloqueadosIds: cargosBloqueados.map((c) => c.id) };
});

const mapCargos = (copy) => copy.cargos.map((cargo) => ({
  ...cargo,
  disabledByAlert: copy.alertas.some((a) => a.cargosBloqueadosIds.includes(cargo.id)),
}));

const hasBloqueoAlertas = (copy) => copy.alertas.some((a) => a.cargosBloqueadosIds.length);

const hasAlertasRestrictivas = (copy) => copy.hasBloqueoAlertas
  || copy.alertas.some((a) => a.es_restrictiva);

const hasAlertas = (copy) => copy.hasAlertasRestrictivas || !!copy.alertas.length;

// Action handlers
const clean = (_state, preservePublicoGeneral) => {
  if (preservePublicoGeneral) {
    const [ciudadano] = _state.padrones;
    ciudadano.cargos = [];
    ciudadano.requiereFetch = true;
    const state = { ...initialState };
    state.ciudadano = _state.ciudadano;
    state.recibos = _state.recibos;
    state.padrones = [ciudadano];
    state.selectedRowKeys = {
      [ciudadano.key]: [],
    };
    state.cargosPublicoGeneral = [];
    return state;
  }
  return {
    ...initialState,
    recibos: _state.recibos,
  };
};

const setPadrones = (_state, padrones) => {
  const state = JSON.parse(JSON.stringify(_state));
  if (Array.isArray(padrones)) {
    [state.ciudadano] = padrones;
    state.padrones = padrones.map(({ cargos, ...padron }) => {
      padron.key = `${padron.id}_${padron.tipo_de_padron}`;
      padron.requireData = requireUpdate(padron);
      state.selectedRowKeys[padron.key] = [];
      const _cargos = normalizeCargos(cargos);
      return {
        ...padron,
        cargos: _cargos,
      };
    });
  }
  return state;
};

const addPadron = (_state, padron) => {
  const state = JSON.parse(JSON.stringify(_state));
  padron.alertas = padron.alertas || [];
  padron.key = padron.key || `${padron.id}_${padron.tipo_de_padron}`;
  padron.requiereFetch = 'requiereFetch' in padron ? padron.requiereFetch : true;
  padron.requireData = requireUpdate(padron);
  padron.cargos = padron.isCopy || padron.keepCargos ? padron.cargos || [] : [];
  if (padron.keepCargos) {
    padron.cargos = normalizeCargos(padron.cargos);
  }
  if (padron.cargos.length) {
    padron.fechaUltimaActualizacionCargos = new Date();
  }
  if (padron.isCopy) {
    const padronOriginalIdx = state.padrones.findIndex((p) => {
      const isSamePadron = p.id === padron.id && p.tipo_de_padron === padron.tipo_de_padron;
      if (padron.cargos[0].sistema) {
        // encuentra instancia de sistema
        return isSamePadron && p.sistema?.id === padron.cargos[0].sistema.id;
      }
      // encuentra instancia "original/libre"
      return isSamePadron && !p.isCopy && !p.tramite && !p.sistema;
    });
    const padronOriginal = state.padrones[padronOriginalIdx];
    state.padrones[padronOriginalIdx].cargos = state.padrones[padronOriginalIdx].cargos
      .filter((c) => !padron.cargos.some((_c) => _c.id === c.id));

    state.selectedRowKeys[padronOriginal.key] = state.selectedRowKeys[padronOriginal.key]
      .filter((k) => !padron.cargos.some((c) => c.id === k));
  } else if (padron?.es_publico_general) {
    state.ciudadano = padron;
  }
  state.selectedRowKeys[padron.key] = !padron?.convenio ? padron.cargos.map((c) => c.id) : [];

  padron.alertas = mapAlertas(padron.alertas, padron.cargos);
  padron.cargos = mapCargos(padron);
  padron.hasBloqueoAlertas = hasBloqueoAlertas(padron);
  padron.hasAlertasRestrictivas = hasAlertasRestrictivas(padron);
  padron.hasAlertas = hasAlertas(padron);

  state.padrones = [...state.padrones, padron];
  // Normalizing Values
  return state;
};

const addPadrones = (_state, padrones) => {
  const state = JSON.parse(JSON.stringify(_state));
  if (Array.isArray(padrones)) {
    // [state.ciudadano] = padrones;
    state.padrones = [
      ...state.padrones,
      ...padrones.map(({ cargos, ...padron }) => {
        padron.key = padron.key || `${padron.id}_${padron.tipo_de_padron}`;
        padron.requireData = requireUpdate(padron);
        state.selectedRowKeys[padron.key] = [];
        const _cargos = normalizeCargos(cargos);
        return {
          ...padron,
          cargos: _cargos,
          requiereFetch: padrones.length < 10,
        };
      }),
    ];

    // Normalizing Values
    state.padrones.forEach((padron, idx) => {
      state.padrones[idx].fechaUltimaActualizacionCargos = new Date();
    });
  }
  return state;
};

const removePadron = (_state, padron) => {
  const state = JSON.parse(JSON.stringify(_state));
  const selectedRowKeys = { ...state.selectedRowKeys };
  delete selectedRowKeys[padron.key];
  state.padrones = state.padrones.filter((p) => p.key !== padron.key);
  state.selectedRowKeys = selectedRowKeys;
  if (padron.isCopy && !padron.tramite) {
    const idxOriginal = state.padrones.findIndex((p) => !p.tramite
      && p.sistema?.id === padron.cargos[0]?.sistema?.id
      && p.id === padron.id && p.tipo_de_padron === padron.tipo_de_padron);
    const copies = state.padrones.filter((p) => p.id === padron.id
      && p.tipo_de_padron === padron.tipo_de_padron && p.isCopy && p.key !== padron.key);
    copies.forEach((copy, idx) => {
      const idxPadron = state.padrones.findIndex((p) => p.key === copy.key);
      state.padrones[idxPadron].copyNumber = idx + 1;
    });
    // aplicar sorterCargos en select store
    state.padrones[idxOriginal].cargos = [
      ...state.padrones[idxOriginal].cargos,
      ...padron.cargos,
    ];
    state.padrones = state.padrones.filter((p) => p.key !== padron.key);
  }
  return state;
};

const setCargosPadron = (_state, payload) => {
  const state = JSON.parse(JSON.stringify(_state));
  const { key, cargos, alertas = [] } = payload;
  const padronIdx = state.padrones.findIndex((p) => p.key === key);
  const padron = state.padrones[padronIdx];
  if (!padron) return state;

  padron.plantillas = payload.plantillas;
  padron.tramites_bloqueando_adeudos = payload.tramites_bloqueando_adeudos;

  const copies = state.padrones.filter((p) => {
    const isSamePadron = p.id === padron.id && p.tipo_de_padron === padron.tipo_de_padron;
    const hasAttributes = p.isCopy || p.tramite || p.sistema || p.convenio;
    return isSamePadron && hasAttributes;
  });

  const cargosSistemasTramites = filterCargosSistemasTramites(cargos);

  state.padrones[padronIdx].alertas = alertas || padron.alertas;

  // se movieron cargos a una copia existente
  if (padron.isCopy) {
    // asignamos todos los cargos a la misma copia, y selecionamos las keys
    padron.cargos = [...padron.cargos, ...cargos];
    state.selectedRowKeys[key] = [
      ...state.selectedRowKeys[key],
      ...cargos.map((c) => c.id),
    ];
    // normalizamos datos de instancia original
    const padronOriginalIdx = state.padrones.findIndex((p) => !p.tramite
      && p.id === padron.id && p.tipo_de_padron === padron.tipo_de_padron
      && p.sistema?.id === cargos[0].sistema?.id);
    const padronOriginal = state.padrones[padronOriginalIdx];
    state.padrones[padronOriginalIdx].cargos = state.padrones[padronOriginalIdx].cargos
      .filter((c) => !cargos.some((_c) => _c.id === c.id));
    state.selectedRowKeys[padronOriginal.key] = state.selectedRowKeys[padronOriginal.key]
      .filter((k) => !cargos.some((c) => c.id === k));
  } else {
    // Padron recien cargado o con request de adeudo 'caducado'
    // Actualizando cargos por que se llego el vencimiento de la persistencia
    if (padron.fechaUltimaActualizacionCargos) {
      // eliminamos todos los datos referentes a las copias
      copies.forEach((copy) => {
        delete state.selectedRowKeys[copy.key];
      });
      state.padrones = state.padrones.filter((p) => !copies.some((c) => c.key === p.key));
    }
    // Se crean copias de tramites y sistemas en primer carga
    const idsSistemas = [...new Set(cargosSistemasTramites
      .filter((e) => e.tipo_de_cargo.sistemas)
      .map((e) => e.tipo_de_cargo.sistemas?.id))];
    const sistemas = idsSistemas.map((s) => cargosSistemasTramites
      .find((c) => c.tipo_de_cargo.sistemas?.id === s)?.tipo_de_cargo.sistemas);

    const idsTramites = [...new Set(cargosSistemasTramites
      .filter((e) => e.tramite).map((e) => e.tramite.id))];
    const tramites = idsTramites.map((t) => cargosSistemasTramites
      .find((c) => c.tramite?.id === t)?.tramite);

    const copiesTramitesSistemas = [];

    tramites.forEach((tramite) => {
      const plantilla = padron.plantillas.find((p) => p.id === tramite.plantilla);
      const cargosTramite = cargosSistemasTramites.filter((c) => c.tramite?.id === tramite.id);
      const _padron = {
        ...padron,
        ...(plantilla?.use_json ? padron.json_predio : {}),
        alerta: padron.alerta,
        tramite,
        disabledOrdenPago: plantilla?.disabledOrdenPago,
        use_json: plantilla?.use_json,
        key: `${padron.key}__tramite_${tramite.id}`,
        cargos: normalizeCargos(cargosTramite),
        // isCopy: true,
        requiereFetch: false,
        fechaUltimaActualizacionCargos: new Date(),
      };
      copiesTramitesSistemas.push(_padron);
    });

    // Se hizo de esta manera porque la lista de convenios llega desactualizada
    // sin el nuevo convenio pero los cargos si llegan actualizados
    const conveniosIds = [...new Set(cargos
      .filter((c) => c?.convenios && [1, 4].includes(c?.convenios?.estados_globales))
      .map((c) => c?.convenios?.id))];

    conveniosIds.sort((a, b) => b + a).forEach((convenioId) => {
      const cargosConvenio = cargos.filter((c) => c?.convenios?.id === convenioId
        && !(c.tramite || c.sistema) && c.cargo_conveniado);
      const convenio = cargosConvenio[0]?.convenios;

      if (cargosConvenio.length && [1, 4].includes(convenio.estados_globales)) {
        copiesTramitesSistemas.push({
          ...padron,
          cargos: normalizeCargos(cargosConvenio),
          key: `${padron.key}__convenio_${convenio?.id}`,
          requiereFetch: false,
          fechaUltimaActualizacionCargos: new Date(),
          convenio: convenio?.id,
          convenioFolio: convenio?.folio || convenio?.id,
        });
      }
    });
    const sistemaPredial = sistemas.find((s) => /predial/i.test(s.descripcion));
    const now = Moment(new Date());

    const periodosEnum = {
      DIARIO: 2,
      SEMANAL: 3,
      QUINCENAL: 4,
      MENSUAL: 5,
      BIMESTRAL: 6,
      TRIMESTRAL: 7,
      CUATRIMESTRAL: 8,
      SEMESTRAL: 9,
      ANUAL: 10,
    };

    const periodoToMomentUnit = Object.freeze({
      [periodosEnum.DIARIO]: 'day',
      [periodosEnum.SEMANAL]: 'week',
      [periodosEnum.QUINCENAL]: 'day',
      [periodosEnum.MENSUAL]: 'month',
      [periodosEnum.BIMESTRAL]: 'month',
      [periodosEnum.TRIMESTRAL]: 'month',
      [periodosEnum.CUATRIMESTRAL]: 'month',
      [periodosEnum.SEMESTRAL]: 'month',
    });

    const periodoToMomentUnitQty = Object.freeze({
      [periodosEnum.QUINCENAL]: 15,
      [periodosEnum.BIMESTRAL]: 2,
      [periodosEnum.TRIMESTRAL]: 3,
      [periodosEnum.CUATRIMESTRAL]: 4,
      [periodosEnum.SEMESTRAL]: 6,
    });

    sistemas.forEach((sistema) => {
      const cargosPadres = cargosSistemasTramites
        .filter((c) => (!c.es_accesorio && c.tipo_de_cargo.sistemas?.id === sistema.id));
      const accesorios = cargosPadres.map((cp) => cargosSistemasTramites
        .filter((_c) => _c.es_accesorio && _c.cargo_padre === cp.id)).flat();
      const _cargosSistema = normalizeCargos([...cargosPadres, ...accesorios]);
      const cargosSistemaSinTramite = _cargosSistema.filter((c) => !c.tramite && !c?.convenios);
      if (sistema.id === sistemaPredial?.id && cargos.length) {
        const cargo = cargos
          .find((c) => c.fecha_de_vencimiento && /impuesto predial/i.test(c.descripcion));

        if (!cargo) return;

        const periodo = cargo.tipo_de_cargo.periodo || cargo.tipo_de_cargo.periodo_fiscal.periodo;
        const fecha_de_vencimiento = cargo.fecha_de_vencimiento
          || cargo.tipo_de_cargo.fecha_de_vencimiento;
        sistemaPredial.fechavencimiento = fecha_de_vencimiento?.add(
          -(periodoToMomentUnitQty[periodo] || 1),
          periodoToMomentUnit[periodo],
        );
      }
      if (cargosSistemaSinTramite.length) {
        copiesTramitesSistemas.push({
          ...padron,
          sistema,
          key: `${padron.key}__sistema_${sistema.id}`,
          cargos: cargosSistemaSinTramite.map((c) => ({ ...c, sistema })),
          requiereFetch: false,
          fechaUltimaActualizacionCargos: new Date(),
          // isCopy: true,
          // disabled: se debe identificar si hay cargos de refrendo en esta copia de sistema y en
          // algun otra copia de trámite para deshabilitar
        });
      }
    });
    if (padron.tipo_de_padron === 3) {
      padron.no_adeudo_predial = !sistemaPredial
        || !sistemaPredial.fechavencimiento || sistemaPredial.fechavencimiento.isAfter(now);
      if (padron.no_adeudo_predial) {
        padron.fechavencimiento = sistemaPredial?.fechavencimiento
          || Moment(new Date()).endOf('year');
      }
    }
    padron.cargos = normalizeCargos(cargos
      .filter((k) => !cargosSistemasTramites.some((c) => c.id === k.id)));
    if (copiesTramitesSistemas.length) {
      copiesTramitesSistemas.forEach((copy, i) => {
        state.selectedRowKeys[copy.key] = copy.cargos
          .filter((c) => c.tipo_de_cargo.es_pago_obligatorio
            && !copy.alertas.some((a) => a.cargosBloqueadosIds.includes(c.id)))
          .map((e) => e.id);
        copiesTramitesSistemas[i].alertas = mapAlertas(
          padron.alertas,
          copiesTramitesSistemas[i].cargos,
        );
        copiesTramitesSistemas[i].cargos = mapCargos(copiesTramitesSistemas[i]);
        copiesTramitesSistemas[i].hasBloqueoAlertas = hasBloqueoAlertas(copiesTramitesSistemas[i]);
        copiesTramitesSistemas[i]
          .hasAlertasRestrictivas = hasAlertasRestrictivas(copiesTramitesSistemas[i]);
        copiesTramitesSistemas[i]
          .hasAlertas = hasAlertas(copiesTramitesSistemas[i]);
      });
      state.padrones = [...state.padrones, ...copiesTramitesSistemas];
    }
  }

  padron.alertas = mapAlertas(padron.alertas, padron.cargos);
  padron.cargos = mapCargos(padron);
  padron.hasBloqueoAlertas = hasBloqueoAlertas(padron);
  padron.hasAlertasRestrictivas = hasAlertasRestrictivas(padron);
  padron.hasAlertas = hasAlertas(padron);

  padron.requiereFetch = false;
  padron.fechaUltimaActualizacionCargos = new Date();
  state.padrones[padronIdx] = padron;

  return state;
};

const setSelectedRowKeys = (_state, { key, selectedRowKeys }) => {
  const state = JSON.parse(JSON.stringify(_state));
  if (selectedRowKeys.length) {
    state.selectedRowKeys[key] = selectedRowKeys;
    return state;
  }

  const { cargos } = state.padrones.find((p) => p.key === key);
  const mandatoryKeys = state.selectedRowKeys[key]
    .filter((k) => cargos.find((c) => c.id === k).tipo_de_cargo.es_pago_obligatorio);
  state.selectedRowKeys[key] = mandatoryKeys;
  return state;
};

const setPadronRequiereFetch = (_state, key) => {
  const state = JSON.parse(JSON.stringify(_state));

  let padron = state.padrones.find((p) => p.key === key
    && !p.tramite && !p.sistema && !p.convenio);

  if (!padron) {
    const [_key, tipoDePadron] = key.split('__')[0].split('_');
    const _tipoDePadron = parseInt(tipoDePadron, 10);

    padron = state.padrones.find((p) => p.id === _key
      && p.tipo_de_padron === _tipoDePadron
      && !(p.tramite || p.sistema || p.convenio));

    if (!padron) {
      padron = state.padrones.find((p) => p.key === key);
      state.selectedRowKeys[padron.key] = [];
      state.padrones = state.padrones.filter((p) => p.key !== padron.key);
    }
  }

  if (!padron.isCopy && !padron.tramite && !padron.sistema && !padron.convenio) {
    const padronIdx = state.padrones.findIndex((p) => p.key === padron.key);
    state.padrones[padronIdx].requiereFetch = true;
    state.padrones[padronIdx].cargos = [];
    state.selectedRowKeys[padron.key] = [];
  }

  const copies = state.padrones.filter((p) => {
    const isSamePadron = p.id === padron.id && p.tipo_de_padron === padron.tipo_de_padron;
    const hasAttributes = p.isCopy || p.tramite || p.sistema || p.convenio;
    return isSamePadron && hasAttributes;
  });

  copies.forEach((c) => {
    state.selectedRowKeys[c.key] = [];
  });

  state.padrones = state.padrones.filter((p) => !copies.some((c) => c.key === p.key));

  return state;
};

const setObservaciones = (_state, { padronKey, observaciones }) => {
  const state = JSON.parse(JSON.stringify(_state));
  const padronIdx = state.padrones.findIndex((p) => p.key === padronKey);
  state.padrones[padronIdx].observaciones = observaciones;
  return state;
};

const setRecibosOrden = (_state, payload) => {
  const state = JSON.parse(JSON.stringify(_state));
  state.recibos = payload;
  return state;
};

const setRecibos = (state, recibos = []) => ({ ...state, recibos });
const setNetPayResponse = (state, payload) => ({ ...state, netpayResponse: payload });
const clearNetPayResponse = (state) => ({ ...state, netpayResponse: null });
const setPinPadron = (propName) => (state, payload) => ({ ...state, [propName]: payload });
const setCargosPublicoGeneral = (state, payload) => ({ ...state, cargosPublicoGeneral: payload });
const setLastPaymentData = (state, payload) => ({ ...state, lastPaymentData: payload });
const setLastPaymentDataConvenio = (state, payload) => ({
  ...state,
  lastPaymentDataConvenio: payload,
});
const setReciboConvenio = (state, payload) => ({ ...state, reciboConvenio: payload });
const setRecibosCancelados = (state, payload) => ({ ...state, recibosCancelados: payload });

const ACTION_HANDLER = {
  [CLEAN_CAJA]: clean,
  [SET_PADRONES]: setPadrones,
  [ADD_PADRON]: addPadron,
  [ADD_PADRONES]: addPadrones,
  [REMOVE_PADRON]: removePadron,
  [SET_CARGOS_PADRON]: setCargosPadron,
  [SET_SELECTEDROWKEYS]: setSelectedRowKeys,
  [SET_RECIBOS]: setRecibos,
  [SET_RECIBOS_ORDEN]: setRecibosOrden,
  [SET_RECIBO_CONVENIO]: setReciboConvenio,
  [SET_NETPAY_RESPONSE]: setNetPayResponse,
  [CLEAR_NETPAY_RESPONSE]: clearNetPayResponse,
  [SET_PIN_PADRON_AGREGAR_CARGOS]: setPinPadron('pinPadronAgregarCargos'),
  [SET_PIN_PADRON_INFO]: setPinPadron('pinPadronInfo'),
  [SET_PIN_PADRON_COMENTARIO]: setPinPadron('pinPadronComentario'),
  [SET_PIN_PADRON_ALERTAS]: setPinPadron('pinPadronAlertas'),
  [SET_PADRON_PAGO_CONVENIO]: setPinPadron('padronPagoConvenio'),
  [SET_PADRON_REQUIERE_FETCH]: setPadronRequiereFetch,
  [SET_OBSERVACIONES]: setObservaciones,
  [SET_CARGOS_PUBLICO_GENERAL]: setCargosPublicoGeneral,
  [SET_LAST_PAYMENT_DATA]: setLastPaymentData,
  [SET_LAST_PAYMENT_DATA_CONVENIO]: setLastPaymentDataConvenio,
  [SET_RECIBOS_CANCELADOS]: setRecibosCancelados,
};

export default (state = initialState, action) => {
  const handler = ACTION_HANDLER[action.type];
  return handler ? handler(state, action.payload) : state;
};
